import Vue from 'vue'
import App from './App.vue'
import axios from 'axios'
import Qs from 'qs'
import VueAxios from 'vue-axios'
Vue.prototype.$axios = axios
var axios_instance = axios.create({
  baseURL:'http://localhost',
  transformRequest: [function (data) {
  data = Qs.stringify(data);
  return data;
  }],
  headers:{'Content-Type':'application/x-www-form-urlencoded'}
})
Vue.use(VueAxios, axios_instance)
Vue.config.productionTip = false

new Vue({
  render: h => h(App),
}).$mount('#app')



// WEBPACK FOOTER //
// ./src/main.js